import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        try {
            localStorage.removeItem('admintoken');
            navigate('/admin/adminlogin');
        } catch (error) {
            console.log(error.message);
        }
    };
    return (
        <div>

            <div className='navbar bg-primary text-primary-content '>
                <div className='navbar-start'>
                    <div>
                        <a className='btn btn-ghost text-xl'>MedAppointHub </a>
                    </div>

                </div>
                <div className='navbar-center'>
                    <a className='btn btn-ghost text-xl'>ADMIN</a>
                </div>
                <div className='navbar-end'>
                    <button className='bg-red-700 rounded-2xl w-20 h-7' onClick={handleLogout}>LOGOUT</button>

                    <div className='dropdown'>


                    </div>
                    {/* <button className='btn btn-ghost btn-circle'>
                        <svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' /></svg>
                    </button> */}
                    <button className='btn btn-ghost btn-circle'>
                        <div className='indicator'>
                            <svg xmlns='http://www.w3.org/2000/svg' className='h-5 w-5' fill='none' viewBox='0 0 24 24' stroke='currentColor'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9' /></svg>
                            <span className='badge badge-xs badge-primary indicator-item'></span>
                        </div>
                    </button>
                </div>
            </div>
        </div>

    );
};

export default Header;